"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageAction = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class PageAction {
  constructor() {
    (0, _defineProperty2.default)(this, "settings", {
      page: {
        type: "page",
        description: "The page to open."
      },
      pathParam: {
        type: "args",
        title: "Link Variable Values",
        description: "Values for the link variables the page has.",
        path: true,
        compact: true
      }
    });
    (0, _defineProperty2.default)(this, "type", "page");
    (0, _defineProperty2.default)(this, "label", "Open Page");
    (0, _defineProperty2.default)(this, "description", "Open a different Palette page.");
  }
  resolve(spec, resolver) {
    var _spec$param$pathParam;
    let action = {
      type: "page",
      page: typeof spec.param.page === "string" ? spec.param.page : resolver.resolveString(spec.param.page),
      path: []
    };
    if (((_spec$param$pathParam = spec.param.pathParam) === null || _spec$param$pathParam === void 0 ? void 0 : _spec$param$pathParam.length) > 0) {
      for (let part of spec.param.pathParam) {
        if (part !== null && part !== void 0 && part.type) {
          let res = resolver.resolve(part);
          action.path.push(resolver.resolveString(part));
        } else {
          action.path.push(null);
        }
      }
    }
    return action;
  }
}
exports.PageAction = PageAction;
//# sourceMappingURL=PageAction.js.map